import Slider from '../slider';

export default (element) => {
  const createSlider = () => {
    const slider = new Slider({
      el: element.querySelector('[data-category-slider]'),
      options: {
        slidesPerView: 2.5,
        spaceBetween: 8,
        breakpoints: {
          1024: {
            slidesPerView: 7,
            spaceBetween: 16,
            centerInsufficientSlides: true,
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: '!hidden',
        },
        on: {
          snapGridLengthChange() {
            const slides = element.querySelectorAll('.swiper-slide');
            slides.forEach((slide) => {
              slide.classList.remove('hidden');
            });
          },
        },
      },
    });
    return slider;
  };

  createSlider();
};
